import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  selected: "",
  value: "0001"
}
const _hoisted_2 = {
  key: 1,
  value: "0002"
}
const _hoisted_3 = {
  key: 2,
  value: "0003"
}
const _hoisted_4 = {
  key: 3,
  value: "0006"
}
const _hoisted_5 = {
  key: 4,
  value: "0007"
}
const _hoisted_6 = {
  key: 5,
  value: "0008"
}
const _hoisted_7 = {
  key: 0,
  class: "gev19__contexthelp-text o-grid__cell--no-space"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_infotext = _resolveComponent("infotext")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_Bauartklasse = _resolveComponent("Bauartklasse")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_zeile, null, {
      default: _withCtx(() => [
        _createVNode(_component_titel_zelle, {
          "zeige-info": true,
          "info-box-id": "fertighaus"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode(" Handelt es sich um ein "),
            _createElementVNode("strong", null, "Fertighaus?", -1)
          ])),
          _: 1,
          __: [6]
        }),
        _createVNode(_component_zelle, { class: "mkRadio" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.fertighaus) = $event)),
              type: "radio",
              id: "nichtfertighaus",
              name: "fertighaus",
              value: false,
              required: "",
              "aria-required": "true",
              "aria-label": "Nein, es handelt sich nicht um ein Fertighaus",
              "aria-describedby": "fertighausInfo",
              "data-fehlermeldung": "Bitte treffen Sie eine Auswahl.",
              "data-cy": "fertighausRadioNo"
            }, null, 512), [
              [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.fertighaus]
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("label", {
              for: "nichtfertighaus",
              class: "radiolabel"
            }, "Nein", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.fertighaus) = $event)),
              type: "radio",
              id: "fertighaus",
              name: "fertighaus",
              value: true,
              "aria-label": "Ja, es handelt sich um ein Fertighaus",
              "aria-describedby": "fertighausInfo",
              "data-cy": "fertighausRadioYes"
            }, null, 512), [
              [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.fertighaus]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("label", {
              for: "fertighaus",
              class: "radiolabel"
            }, "Ja", -1)),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler.fertighaus,
              "reduzierter-abstand": true
            }, null, 8, ["fehler-text"]),
            _createVNode(_component_infotext, {
              role: "tooltip",
              id: "fertighausInfo",
              name: "fertighaus",
              "css-klassen": "o-grid__cell--no-space",
              text: "Als Fertighaus bezeichnet man ein Haus, das industriell in einem\n            Werk nahezu komplett vorgefertigt wird. Es wird in Einzelteilen auf\n            die Baustelle geliefert und dort endmontiert."
            })
          ]),
          _: 1,
          __: [7,8]
        })
      ]),
      _: 1
    }),
    _createVNode(_component_zeile, null, {
      default: _withCtx(() => [
        _createVNode(_component_titel_zelle, {
          "zeige-info": true,
          "info-box-id": "bauart"
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createElementVNode("strong", null, "Bauart", -1),
            _createTextVNode(" des Gebäudes")
          ])),
          _: 1,
          __: [9]
        }),
        _createVNode(_component_zelle, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("select", {
              id: "bauart",
              name: "bauart",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.bauart) = $event)),
              class: "c-form-control-select",
              "aria-label": "Bauart des Gebäudes",
              "data-fehlermeldung": "Bitte treffen Sie eine Auswahl.",
              "data-cy": "bauart"
            }, [
              (_ctx.piniaStore.state.gebaeudedaten.fertighaus === false)
                ? (_openBlock(), _createElementBlock("option", _hoisted_1, "Massiv"))
                : _createCommentVNode("", true),
              (_ctx.piniaStore.state.gebaeudedaten.fertighaus === false)
                ? (_openBlock(), _createElementBlock("option", _hoisted_2, " Stahl- oder Holzfachwerk mit Stein-/Glasfüllung "))
                : _createCommentVNode("", true),
              (_ctx.piniaStore.state.gebaeudedaten.fertighaus === false)
                ? (_openBlock(), _createElementBlock("option", _hoisted_3, " Stahl- oder Holzfachwerk mit anderem Füllmaterial "))
                : _createCommentVNode("", true),
              (_ctx.piniaStore.state.gebaeudedaten.fertighaus === true)
                ? (_openBlock(), _createElementBlock("option", _hoisted_4, " Alle Teile feuerbeständig "))
                : _createCommentVNode("", true),
              (_ctx.piniaStore.state.gebaeudedaten.fertighaus === true)
                ? (_openBlock(), _createElementBlock("option", _hoisted_5, " Leichtbauweise mit feuerhemmender Ummantelung "))
                : _createCommentVNode("", true),
              (_ctx.piniaStore.state.gebaeudedaten.fertighaus === true)
                ? (_openBlock(), _createElementBlock("option", _hoisted_6, " Leichtbauweise ohne feuerhemmende Ummantelung "))
                : _createCommentVNode("", true)
            ], 512), [
              [_vModelSelect, _ctx.piniaStore.state.gebaeudedaten.bauart]
            ]),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler.bauart,
              "reduzierter-abstand": true
            }, null, 8, ["fehler-text"]),
            (_ctx.istSichtbar('bauart'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _cache[10] || (_cache[10] = _createTextVNode(" Die Bauart bestimmt die Bauartklasse des Gebäudes und hat somit Einfluss auf die Beitragshöhe. Bei gemischter Bauweise ist die weniger massive Bauart zu wählen. Details zu den verschiedenen Bauarten finden Sie ")),
                  _createElementVNode("a", {
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleBauartCheck && _ctx.toggleBauartCheck(...args)), ["stop"]))
                  }, "hier.")
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_zeile, null, {
      default: _withCtx(() => [
        _createVNode(_component_titel_zelle, {
          "zeige-info": true,
          "info-box-id": "dachbelag"
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createTextVNode(" Art des "),
            _createElementVNode("strong", null, "Dachbelags", -1)
          ])),
          _: 1,
          __: [11]
        }),
        _createVNode(_component_zelle, { class: "mkRadio" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.dachbelag) = $event)),
              type: "radio",
              id: "dachbelagHart",
              name: "dachbelag",
              value: "0",
              "data-fehlermeldung": "Bitte treffen Sie eine Auswahl.",
              required: "",
              "aria-required": "true",
              "aria-label": "Hartes Dach",
              "aria-describedby": "dachbelag",
              disabled: _ctx.piniaStore.state.gebaeudedaten.fertighaus === true
            }, null, 8, _hoisted_8), [
              [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.dachbelag]
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("label", {
              for: "dachbelagHart",
              class: "radiolabel"
            }, "Hart", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.dachbelag) = $event)),
              type: "radio",
              id: "dachbelagWeich",
              name: "dachbelag",
              value: "1",
              "aria-label": "Weiches Dach",
              "aria-describedby": "dachbelag",
              disabled: _ctx.piniaStore.state.gebaeudedaten.fertighaus === true
            }, null, 8, _hoisted_9), [
              [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.dachbelag]
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("label", {
              for: "dachbelagWeich",
              class: "radiolabel"
            }, "Weich", -1)),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler.dachbelag,
              "reduzierter-abstand": true
            }, null, 8, ["fehler-text"]),
            _createVNode(_component_infotext, {
              role: "tooltip",
              id: "dachbelag",
              name: "dachbelag",
              "css-klassen": "o-grid__cell--no-space",
              text: "Harte Bedachung wie z.B. Ziegel, weiche Bedachung wie z. B. Holz oder Reet (Schilf)."
            })
          ]),
          _: 1,
          __: [12,13]
        })
      ]),
      _: 1
    }),
    (_ctx.showables.toggleBauart)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          onCloseModal: _ctx.toggleBauartCheck,
          titel: "Bauart- / Fertighausklassen"
        }, {
          inhalt: _withCtx(() => [
            _createVNode(_component_Bauartklasse)
          ]),
          _: 1
        }, 8, ["onCloseModal"]))
      : _createCommentVNode("", true)
  ], 64))
}